import Image from 'next/image'
import { useState } from 'react'
import styled from 'styled-components'

import { colors } from '@/config/global-parameters'

import reportAnalytics from '../analyticsEvents'
import LiveIndicator from './LiveIndicator'

interface IMobileContent {
  allowParams: string
  mobileAutoplay?: boolean
  videoId: string
}

const MobileContent = ({ allowParams, mobileAutoplay, videoId }: IMobileContent) => {
  const disableLive = Boolean(process?.env?.NEXT_PUBLIC_DISABLE_LIVE === 'true')
  const [isActive, setIsActive] = useState<boolean>(false)
  const mobileSourceUrl = `https://www.youtube.com/embed/${videoId}?fs=0&rel=0&modestbranding=1&controls=1&showinfo=0&autohide=1&autoplay=${
    mobileAutoplay ? '1' : '0'
  }`
  const sendSignalMobile = () => {
    setIsActive(!isActive)
    if (!isActive) reportAnalytics('mobile_live_video_event')
  }
  return (
    <MobileContainer>
      <LiveIndicator
        active={!disableLive}
        animated={!isActive}
        centered
        handleClick={sendSignalMobile}
      />
      {isActive && (
        <MobileVideoContainer>
          <MobileIframe
            allow={allowParams}
            frameBorder="0"
            src={mobileSourceUrl}
            title="YouTube Video Player"
          />
          <MobileVideoLabelContainer>
            <LiveIndicator active={!disableLive} />
            <a
              href={`https://www.youtube.com/watch?v=${videoId}}`}
              rel="noreferrer"
              target="_blank"
            >
              <MobileVideoLabel>
                <span>Análisis en Vivo</span>
              </MobileVideoLabel>
            </a>
          </MobileVideoLabelContainer>
          <CloseButton
            alt="close"
            height="9"
            onClick={() => setIsActive(false)}
            src="/images/close.svg"
            width="9"
          />
        </MobileVideoContainer>
      )}
    </MobileContainer>
  )
}

const mobileHeight = '70px'

const MobileVideoContainer = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  height: ${mobileHeight};
  width: 100%;
  background-color: ${colors.colorWhite};
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2);
  display: grid;
  flex-direction: column;
  grid: 1fr / 140px 4fr 1fr;
  justify-content: center;
  align-items: center;
`
const MobileIframe = styled.iframe`
  height: ${mobileHeight};
  width: 100%;
`
const MobileVideoLabelContainer = styled.div`
  display: flex;
  gap: 20px;
  padding-left: 20px;
`
const MobileVideoLabel = styled.div`
  font-size: 14px;
  color: ${colors.colorBlack};
  font-weight: 400;
  display: flex;
  flex-direction: column;
`
const CloseButton = styled(Image)`
  :hover {
    cursor: pointer;
  }
  justify-self: flex-start;
`
export const MobileContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px ${colors.colorGrey13};
  padding: 4px 15px;
  width: 20%;
  min-width: 80px;
  background-color: ${colors.colorWhite};
  z-index: 2;
`
export default MobileContent
